import Axios from 'axios';

export const ApiService = Axios.create({
    baseURL: `${link_url}`,
});
